import { render, staticRenderFns } from "./ViewCustomerDetails.html?vue&type=template&id=5ffaed2a&scoped=true&external"
import script from "./ViewCustomerDetails.js?vue&type=script&lang=js&external"
export * from "./ViewCustomerDetails.js?vue&type=script&lang=js&external"
import style0 from "./ViewCustomerDetails.scss?vue&type=style&index=0&id=5ffaed2a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffaed2a",
  null
  
)

export default component.exports